// extracted by mini-css-extract-plugin
export default {"cell":"cell__kH0XwvXT","clipboardIcon":"clipboardIcon__QOqgYq0L","clipboard":"clipboard__nV2rhEAI","copyButton":"copyButton__ukEuViJz"};